import hash from 'object-hash';
import { editFactory } from '@/main/pages';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageInfo, PageManager } from '@/main/store/pageManager';
import { TABLE_SCHEMA_DATA } from '@/main/store/listEditTypes';

import { ZalohyStoreModule } from './store/edit';
import { POLOZKY } from './constants';


export function zalohyFactory<T extends ZalohyStoreModule>(name: string, store: T) {
	return editFactory(name, store).extend({
		name,
		data() {
			return {
				dependencies: [POLOZKY],
			};
		},
		computed: {
			...genVuexComputeds(store),
			isFormDataChanged(): boolean {
				const { hash: polozkyHash, rows: polozkyRows } = this.dependentTables.Polozky;
				return hash(this.edit) !== this.editHash || polozkyHash !== hash(polozkyRows);
			},
			isModified(): boolean {
				return this.isEditForm && this.isFormDataChanged;
			},
			previousPageMgr(): PageInfo | null {
				return (this.$store.state.pageManager as PageManager).pages[this.$store.state.pageManager.pages.length - 2] ?? null;
			},
		},
		methods: {
			async fetchTableSchemaData(): Promise<any> {
				return this.$store.dispatch(`${this.storeUri}/${POLOZKY}_${TABLE_SCHEMA_DATA}`);
			},
			async saveClick() {
				const result: any = await this.save();
				if (result instanceof Error) return;
				this.updateTableHash({ uri: `dependentTables.${POLOZKY}` });
			},
		},
	});
}
